// كل فتح جديد للمنصة (تبويب/نافذة جديدة أو فتح التطبيق من الأيقونة) يبدأ من صفحة البداية
// بلا مستخدم سابق. تحديث الصفحة داخل نفس التبويب لا يسجّل الخروج.
try {
  if (!sessionStorage.getItem("app_session_started")) {
    ["token", "user", "bh_school"].forEach((k) => localStorage.removeItem(k));
    sessionStorage.setItem("app_session_started", "1");
  }
} catch { /* إن تعذر التخزين نكمل بشكل عادي */ }
